import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { Customer } from '@app/core/business/customer/customer';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay, switchMapTo } from 'rxjs/operators';
import { Address } from '@app/core/business/address';
import { DeliveryDate } from '@app/core/business/order/delivery-date';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private baseUrl: string = environment.baseApiUrl;

  private customerMocks: Customer[] = [
    {
      code: 'super_u',
      inactive: false,
      isFrancoUnique: false,
      dateCourte: true,
      isFrancoSaisonnier: false,
      isFrancoAmenage: false,
      businessName: 'Super U',
      hasValidatedTerms: true,
      businessContacts: [
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Provence',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Sud ouest',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Sud ouest',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
      ],
      defaultBusinessContactMail: '',
    },
    {
      code: 'carrefour',
      inactive: false,
      isFrancoUnique: false,
      dateCourte: true,
      isFrancoSaisonnier: false,
      isFrancoAmenage: false,
      businessName: 'Carrefour',
      hasValidatedTerms: false,
      businessContacts: [
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Provence',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Sud ouest',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Sud ouest',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
      ],
      defaultBusinessContactMail: '',
    },
    {
      code: 'geant',
      dateCourte: true,
      inactive: false,
      isFrancoUnique: false,
      isFrancoSaisonnier: false,
      isFrancoAmenage: false,
      businessName: 'Géant',
      hasValidatedTerms: false,
      businessContacts: [
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Provence',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Sud ouest',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Sud ouest',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
      ],
      defaultBusinessContactMail: '',
    },
    {
      code: 'monoprix',
      inactive: false,
      dateCourte: true,
      isFrancoUnique: false,
      isFrancoSaisonnier: false,
      isFrancoAmenage: false,
      businessName: 'Monoprix',
      hasValidatedTerms: false,
      businessContacts: [
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Provence',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Sud ouest',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Sud ouest',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
      ],
      defaultBusinessContactMail: '',
    },
    {
      code: 'auchan',
      dateCourte: true,
      inactive: false,
      isFrancoUnique: false,
      isFrancoSaisonnier: false,
      isFrancoAmenage: false,
      businessName: 'Auchan',
      hasValidatedTerms: false,
      businessContacts: [
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Provence',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Sud ouest',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
        {
          firstName: 'Nicolas',
          lastName: 'Ferrary',
          email: 'nicolas.ferrary@pronatura.com',
          role: '',
          phoneNumber: '+33 4 90 78 73 25',
          center: 'ProNatura Sud ouest',
          mobilePhoneNumber: '+33 4 90 78 73 25',
        },
        {
          firstName: 'Alix',
          lastName: 'Letexier',
          email: 'alix.letexier@pronatura.com',
          role: '',
          phoneNumber: '+33 2 44 76 38 02',
          center: 'ProNatura Pays de la Loire',
          mobilePhoneNumber: '+33 2 44 76 38 02',
        },
      ],
      defaultBusinessContactMail: '',
    },
  ];

  constructor(private http: HttpClient) {}

  /**
   * Get available customers for a contact
   * @param companyCode Code of the company
   * @param contactCode Code of the contact
   */
  public getCustomers(
    companyCode: string,
    contactCode: string
  ): Observable<Customer[]> {
    if (environment.useMock) {
      if (companyCode === 'vf') {
        return of(this.customerMocks.slice(0, 1)).pipe(delay(250));
      }
      return of(this.customerMocks).pipe(delay(200));
    }

    const params: HttpParams = new HttpParams({
      fromObject: {
        contactCode: contactCode,
      },
    });

    return this.http.get<Customer[]>(
      `${this.baseUrl}/companies/${companyCode}/customers`,
      { params: params }
    );
  }

  /**
   * Get a customer
   * @param companyCode Code of the company
   * @param customerCode Code of the customer
   */
  public getCustomer(
    companyCode: string,
    customerCode: string
  ): Observable<Customer> {
    if (environment.useMock) {
      return of(this.customerMocks.find(c => c.code === customerCode)).pipe(
        delay(200)
      );
    }
    return this.http.get<Customer>(
      `${this.baseUrl}/companies/${companyCode}/customers/${customerCode}`
    );
  }

  /**
   * Validate terms of services
   * @param companyCode Code of the company
   * @param customerCode Code of the customer
   */
  public validateTerms(companyCode: string, customerCode: string) {
    if (environment.useMock) {
      this.customerMocks.filter(
        c => c.code === customerCode
      )[0].hasValidatedTerms = true;
      return of(true);
    }

    return this.http.post<any>(
      `${
        this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/terms`,
      ''
    );
  }

  /**
   * Validate terms of services
   * @param companyCode Code of the company
   * @param customerCode Code of the customer
   */
  public validateTermsByGuid(companyCode: string, customerCode: string, guid: string) {
    if (environment.useMock) {
      this.customerMocks.filter(
        c => c.code === customerCode
      )[0].hasValidatedTerms = true;
      return of(true);
    }

    return this.http.post<any>(
      `${
        this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/terms/${guid}`,
      ''
    );
  }

  /**
   * Modification request on page '/dashboard/modification-request'
   * @param companyCode Code of the company
   * @param customerCode Code of the customer
   * @param request Request message
   */
  public modificationRequest(
    companyCode: string,
    customerCode: string,
    request: string
  ): any {
    if (companyCode && customerCode && request) {
      if (environment.useMock) {
        return of(true).pipe(delay(200));
      }

      return this.http.post<any>(
        `${
          this.baseUrl
        }/companies/${companyCode}/customers/${customerCode}/request`,
        {
          request: request,
        }
      );
    }
  }

  public getDeliveryAddresses(
    companyCode: string,
    customerCode: string
  ): Observable<Address[]> {
    return this.http.get<Address[]>(
      `${
        this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/addresses`
    );
  }

  /**
   * Permet de récupérer la liste des dates de livraison
   * CLA le 10/10/2019 - A/B - ajout du type de commande et gestion de la date de livraison avec un objet dédié
   * @param companyCode
   * @param customerCode
   * @param addressCode
   * @param orderType
   */
  public getDeliveryDates(
    companyCode: string,
    customerCode: string,
    addressCode: string,
    orderType: string
  ): Observable<DeliveryDate[]> {
    return this.http.get<DeliveryDate[]>(
      `${
        this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/deliveryDates`,
      { params: { addressCode: addressCode, orderType: orderType } }
    );
  }

  /**
   * Permet de recharger le cache du client
   * BOE le 06112025
   * @param companyCode 
   * @param customerCode 
   */
  public reloadCache$(userlogin:string,companyCode: string,customerCode: string): Observable<any>{
    //Construction de l'url de vidage du cache
    var urlDeleteCache = `${this.baseUrl}/Companies/${companyCode}/Cache/Delete/Customer/${customerCode}`;    
    const deleteCache$ = this.http.get<any>(urlDeleteCache);

    //Recharger le cache
    var urlRebuildCache = `${this.baseUrl}/Companies/${companyCode}/Offers/GEN/External?customerCode=${customerCode}&userlogin=${userlogin}`;  
    const rebuildCache$ = this.http.get<any>(urlRebuildCache);

    return deleteCache$.pipe(switchMapTo(rebuildCache$));
  } 

  public reloadCache(userlogin:string,companyCode: string,customerCode: string){
    this.reloadCache$(userlogin, companyCode, customerCode).subscribe();
  }
}
